import React, { Component } from 'react';
import {
  Header,
  Segment,
  Container,
  Loader,
  Dimmer,
  Card,
  Image,
  Pagination,
  Menu,
} from 'semantic-ui-react';
import uuidv1 from 'uuid/v1';
import _ from 'lodash';
import strip from 'strip';
import removeAccents from 'remove-accents';
import request from 'request';
import ReactGA from 'react-ga';
import moment from 'moment';
import 'moment/locale/fr';
import Feed from 'rss-to-json';

import './App.css';

import blogImg from './assets/img/blog.jpg';
import materniteImg from './assets/img/maternite.jpeg';
import bienetreImg from './assets/img/bienetre.jpg';
import beauteImg from './assets/img/beaute.jpg';

class App extends Component {
  static clickTracker(url) {
    ReactGA.event({
      category: 'External',
      action: `open link ${url}`,
      label: `Go to external link ${url}`,
    });
  }

  constructor() {
    super();

    this.colors = {
      RED: 'red',
      MATERNITE: 'orange',
      BIENETRE: 'yellow',
      BEAUTE: 'olive',
      GREEN: 'green',
      TEAL: 'teal',
      BLUE: 'blue',
      VIOLET: 'violet',
      PURPLE: 'purple',
      BLOG: 'pink',
      BROWN: 'brown',
      GREY: 'grey',
    };
    this.imgs = {
      BLOG: blogImg,
      MATERNITE: materniteImg,
      BIENETRE: bienetreImg,
      BEAUTE: beauteImg,
    };
    this.sources = [
      'http://fetchrss.com/rss/5ae19c238a93f88f3a8b4567113870657.xml',
      'http://fetchrss.com/rss/5ae19c238a93f88f3a8b4567607947025.xml',
      'http://black-in.com/feed/',
      'https://ayanawebzine.com/feed',
    ];
    this.currentColor = this.colors.BLOG;
    this.articleList = [];

    this.state = {
      articles: [],
      loading: true,
    };

    moment.locale('fr');
    ReactGA.initialize('UA-118297870-1');

    this.loadArticles = this.loadArticles.bind(this);
    this.getImgArticle = this.getImgArticle.bind(this);
    this.handlePaginationChange = this.handlePaginationChange.bind(this);
  }

  componentWillMount() {
    this.loadArticles();
  }

  getImgArticle(article) {
    let picture = article.media;

    if (!picture) {
      picture = this.imgs.BLOG;
      this.currentColor = this.colors.BLOG;

      if (article.categories) {
        article.categories.forEach((cat) => {
          const categName = removeAccents(cat.toLowerCase().replace(' ', ''));
          if ((categName !== 'blog') && this.imgs[`${categName.toUpperCase()}`]) {
            picture = this.imgs[`${categName.toUpperCase()}`];
            this.currentColor = this.colors[`${categName.toUpperCase()}`];
          }
        });
      }
    } else {
      picture = article.media.content[0].url[0];
    }

    return { img: picture, color: this.currentColor };
  }

  loadArticles() {
    if (this.sources[0]) {
      request
        .get(this.sources[0])
        .on('response', (response) => {
          if (response.statusCode !== 200) {
            this.sources = this.sources.slice(1, this.sources.length);
            this.loadArticles();
          }

          Feed.load(this.sources[0], (err, rss) => {
            this.sources = this.sources.slice(1, this.sources.length);
            this.articleList = _.concat(this.articleList, rss.items);
            this.setState({
              articles: this.articleList.slice(0, 10),
              loading: false,
            });
            this.loadArticles();
          });
        });
    }
  }

  handlePaginationChange(e, { activePage }) {
    window.scrollTo(0, 0);
    ReactGA.event({
      category: 'Pagination',
      action: `page ${activePage}`,
      label: `Go to page ${activePage}`,
    });
    this.setState({
      articles: this.articleList.slice(((activePage - 1) * 10), (activePage * 10)),
    });
  }

  render() {
    const { loading, articles } = this.state;

    return (
      <div className="App">
        <Menu fluid fixed="top">
          <Segment clearing>
            <Header as="h1" textAlign="center" color="pink">
              Nely News
            </Header>
          </Segment>
        </Menu>

        <Container className="main-content">
          {
            loading &&
            <Dimmer active inverted>
              <Loader size="large">Loading</Loader>
            </Dimmer>
          }
          <Card.Group itemsPerRow={2} stackable>
            {
              articles.map((article) => {
                const articleConfig = this.getImgArticle(article);

                return (
                  <Card key={uuidv1()} color={articleConfig.color}>
                    <Image src={articleConfig.img} />
                    <Card.Content>
                      <Card.Header>
                        {article.title}
                      </Card.Header>
                      <Card.Meta>
                        <span className="author">
                          {article.creator}
                        </span>
                      </Card.Meta>
                      <Card.Description>
                        {strip(article.description)}
                      </Card.Description>
                    </Card.Content>
                    <Card.Content extra>
                      {moment(article.created).format('ll')}
                      <a
                        className="ui pink right floated button"
                        href={`${article.link}?ref=ataajy.lu`}
                        target="_blank"
                        rel="noopener noreferrer"
                        onClick={App.clickTracker(article.link)}
                      >
                        Lire la suite
                      </a>
                    </Card.Content>
                  </Card>
                );
              })
            }
          </Card.Group>
        </Container>
        <Container textAlign="center" id="pagination-container">
          <Pagination
            defaultActivePage={1}
            totalPages={this.articleList.length / 10}
            onPageChange={this.handlePaginationChange}
          />
        </Container>

        <Segment inverted id="footer" textAlign="right">
          <Container>
            <span>Powered by <a href="http://www.ataajy.lu/" target="_blank" rel="noopener noreferrer" onClick={App.clickTracker('http://www.ataajy.lu/')}>Ataajy</a></span>
            <span>Copyright © 2018</span>
          </Container>
        </Segment>
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.jsx